import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Heart, User, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { to: "/", icon: Home, label: "Início" },
  { to: "/categorias", icon: LayoutGrid, label: "Categorias" },
  { to: "/favoritos", icon: Heart, label: "Favoritos" },
  { to: "/conta", icon: User, label: "Conta" },
];

export default function MobileBottomNav() {
  const { count, setOpen } = useCart();
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-neutral-200/80 py-2 px-3 flex justify-around items-center"
    >
      {links.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) => `flex flex-col items-center gap-0.5 px-3 py-1 text-[10px] font-medium ${isActive ? "text-[#C91F1F]" : "text-neutral-600"}`}
        >
          <Icon className="h-5 w-5" />
          <span>{label}</span>
        </NavLink>
      ))}
      <button
        onClick={() => setOpen(true)}
        data-testid="bottom-nav-cart"
        className="relative flex flex-col items-center gap-0.5 px-3 py-1 text-[10px] font-medium text-neutral-600"
      >
        <ShoppingBag className="h-5 w-5" />
        <span>Carrinho</span>
        {count > 0 && (
          <span className="absolute -top-1 right-1 bg-[#C91F1F] text-white text-[9px] font-bold h-4 w-4 rounded-full flex items-center justify-center">
            {count}
          </span>
        )}
      </button>
    </nav>
  );
}
